import { render, staticRenderFns } from "./BitacoraAuditoria.vue?vue&type=template&id=6b0858a2&scoped=true"
import script from "./BitacoraAuditoria.vue?vue&type=script&lang=js"
export * from "./BitacoraAuditoria.vue?vue&type=script&lang=js"
import style0 from "./BitacoraAuditoria.vue?vue&type=style&index=0&id=6b0858a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0858a2",
  null
  
)

export default component.exports